import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 delete_tenant_brand: { message: "idle" },
};

export const delete_tenant_brand_Slice = createSlice({
 name: "delete_tenant_brand",
 initialState,
 reducers: {
  success_delete_tenant_brand: (state, action) => {
   state.delete_tenant_brand = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_delete_tenant_brand: (state, action) => {
   state.delete_tenant_brand = { status: app_consts.FAIL, message: action.payload };
  },
  reset_delete_tenant_brand: (state) => {
   state.delete_tenant_brand = { status: app_consts.IDLE };
  },
  loading_delete_tenant_brand: (state) => {
   state.delete_tenant_brand = { status: app_consts.LOADING };
  },
 }
});

export const { success_delete_tenant_brand, fail_delete_tenant_brand, reset_delete_tenant_brand, loading_delete_tenant_brand } = delete_tenant_brand_Slice.actions;

export default delete_tenant_brand_Slice.reducer;